function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSomeIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-462"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.44,
    y: 391.89,
    width: 34.4,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.94,
    y: 393.67,
    width: 10.28,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 395.45,
    width: 19.36,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.11,
    y: 394.86,
    width: 25.68,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.06,
    y: 391.31,
    width: 17.54,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.81,
    y: 390.91,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.6,
    y: 234.45,
    width: 23.75,
    height: 149.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.83 384.21 437.34 384.21 437.34 371.38 428.1 371.38 432.83 384.21",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.85,
    y: 234.45,
    width: 23.75,
    height: 149.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.66,
    y: 234.45,
    width: 92.68,
    height: 141.89,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.35,
    y: 278.81,
    width: 121.65,
    height: 41.33,
    transform: "translate(113.7 712.65) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 278.81,
    width: 121.65,
    height: 41.33,
    transform: "translate(69.35 668.3) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.91,242.24h-8.18a12.94,12.94,0,0,1-9.39-4h27A12.93,12.93,0,0,1,372.91,242.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.69,242.24h-8.18a12.93,12.93,0,0,1-9.39-4h27A12.94,12.94,0,0,1,417.69,242.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.17 384.21 344.66 384.21 344.66 371.38 353.9 371.38 349.17 384.21",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.29,
    y: 103.62,
    width: 47.02,
    height: 51.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.84,
    y: 103.62,
    width: 48.57,
    height: 51.63,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.37,
    y: 109.22,
    width: 43.49,
    height: 40.43,
    transform: "translate(501.55 -242.69) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.91,
    y: 119.02,
    width: 22.41,
    height: 20.83,
    transform: "translate(501.55 -242.69) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.96,
    y: 73.99,
    width: 211.55,
    height: 141.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.51,
    y: 73.99,
    width: 214.45,
    height: 141.9,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.96,
    y: 215.89,
    width: 211.55,
    height: 10.11,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.57,
    y: 215.89,
    width: 214.45,
    height: 10.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.4,
    y: 45.33,
    width: 126.66,
    height: 199.22,
    transform: "translate(326.67 -36.79) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.43 208.27 174.14 81.61 195.25 81.61 150.54 208.27 129.43 208.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.65,165.3a.55.55,0,0,1-.54-.55V86.56a.54.54,0,0,1,.54-.54.55.55,0,0,1,.55.54v78.19A.55.55,0,0,1,85.65,165.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.07 208.27 199.78 81.61 208.01 81.61 163.3 208.27 155.07 208.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.53,
    y: 144.46,
    width: 126.66,
    height: 0.97,
    transform: "translate(425.8 -135.92) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.76 91.35 79.21 91.35 78.51 84.57 290.06 84.57 290.76 91.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.76 96.32 79.21 96.32 78.51 89.53 290.06 89.53 290.76 96.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.76 102.28 79.21 102.28 78.51 95.49 290.06 95.49 290.76 102.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.76 108.91 79.21 108.91 78.51 102.13 290.06 102.13 290.76 108.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.76 116.86 79.21 116.86 78.51 110.07 290.06 110.07 290.76 116.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.76 125.79 79.21 125.79 78.51 119.01 290.06 119.01 290.76 125.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.56,
    y: 165.44,
    width: 29.63,
    height: 32.54,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 165.44,
    width: 30.61,
    height: 32.54,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.39,
    y: 168.97,
    width: 27.41,
    height: 25.48,
    transform: "translate(562.81 -199.39) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53,182.21v-1a6.57,6.57,0,0,1,6.57-6.56h0a6.56,6.56,0,0,1,6.56,6.56v1a6.56,6.56,0,0,1-6.56,6.56h0A6.57,6.57,0,0,1,374.53,182.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.27,
    y: 134.4,
    width: 34.88,
    height: 38.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.9,
    y: 134.4,
    width: 36.03,
    height: 38.3,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.79,
    y: 138.56,
    width: 32.26,
    height: 29.99,
    transform: "translate(579.47 -272.37) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.92 145.4 417.72 159.6 434.12 159.6 425.92 145.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.35,
    y: 290.01,
    width: 44.84,
    height: 94.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 384.21 291.19 384.21 291.19 371.38 281.95 371.38 286.68 384.21",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.26,
    y: 290.01,
    width: 44.84,
    height: 94.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.17,
    y: 290.01,
    width: 165.02,
    height: 86.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 293.83,
    width: 158.02,
    height: 23.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.85,301.19H200.5a25.87,25.87,0,0,1-18.78-8.08h53.91A25.84,25.84,0,0,1,216.85,301.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.68 384.21 126.17 384.21 126.17 371.38 135.41 371.38 130.68 384.21",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 321.34,
    width: 158.02,
    height: 23.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.85,328.69H200.5a25.9,25.9,0,0,1-18.78-8.07h53.91A25.87,25.87,0,0,1,216.85,328.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 348.84,
    width: 158.02,
    height: 23.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.85,356.2H200.5a25.91,25.91,0,0,1-18.78-8.08h53.91A25.88,25.88,0,0,1,216.85,356.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 244.67,
    width: 26.6,
    height: 44.31,
    transform: "translate(430.6 533.65) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.46,
    y: 245.37,
    width: 1.81,
    height: 44.31,
    transform: "translate(450.73 535.04) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.77,
    y: 245.03,
    width: 5.93,
    height: 44.98,
    rx: 0.64,
    transform: "translate(457.46 535.04) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.77,
    y: 255.3,
    width: 5.93,
    height: 10.51,
    transform: "translate(457.46 521.11) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.77,
    y: 269.05,
    width: 5.93,
    height: 6.48,
    transform: "translate(457.46 544.58) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.01,
    y: 245.03,
    width: 25.25,
    height: 44.98,
    rx: 0.64,
    transform: "translate(425.28 535.04) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.04,
    y: 240,
    width: 29.34,
    height: 48.87,
    transform: "translate(407.42 528.87) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.82,
    y: 240.76,
    width: 1.99,
    height: 48.87,
    transform: "translate(429.63 530.4) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 240.39,
    width: 6.54,
    height: 49.62,
    rx: 0.71,
    transform: "translate(437.05 530.4) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 256.2,
    width: 6.54,
    height: 1.69,
    transform: "translate(437.05 514.08) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 261.1,
    width: 6.54,
    height: 1.69,
    transform: "translate(437.05 523.88) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 266,
    width: 6.54,
    height: 1.69,
    transform: "translate(437.05 533.68) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.85,
    y: 240.39,
    width: 27.85,
    height: 49.62,
    rx: 0.71,
    transform: "translate(401.55 530.4) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.36,
    cy: 272.98,
    r: 7.52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,276.57a5.88,5.88,0,1,1-5.87-5.88A5.87,5.87,0,0,1,140.05,276.57Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.23,
    cy: 276.57,
    r: 7.52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.56,
    cy: 274.36,
    r: 7.52,
    transform: "translate(-91.65 85.66) rotate(-22.39)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.81,275.34s1,14.67,40.6,14.67S198,275.34,198,275.34Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-462"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-462"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.39,
    y: 136.49,
    width: 145.05,
    height: 156.64,
    transform: "translate(76.84 517.38) rotate(-82.4)",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.59,117.32,231.79,288.2l181.44,24.16L436,141.53Zm150.09,159.3-27.19-35.56-30.84,23.58L300.25,204l-48.88,37.37h0l14.51-108.77,155.26,20.71Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.59,117.32,231.79,288.2l181.44,24.16L436,141.53Zm150.09,159.3-27.19-35.56-30.84,23.58L300.25,204l-48.88,37.37h0l14.51-108.77,155.26,20.71Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.88,
    cy: 188.59,
    r: 23.26,
    transform: "translate(31.96 428.61) rotate(-63.71)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.88,
    cy: 188.59,
    r: 23.26,
    transform: "translate(31.96 428.61) rotate(-63.71)",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.7,308.73h0L235.2,285.31a.12.12,0,0,1-.08,0,.1.1,0,0,1,0-.09l22-164.51a.1.1,0,0,1,0-.07.14.14,0,0,1,.09,0L432.67,144a.11.11,0,0,1,.1.13l-22,164.51A.1.1,0,0,1,410.7,308.73ZM235.34,285.1,410.6,308.48,432.53,144.2,257.27,120.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.01,
    y: 157.82,
    width: 164.59,
    height: 152.41,
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,146.73l-183,.79L72.09,320h183ZM233,305.49c-4.74-9.49-11.82-20.54-19.34-21.22,0,0-6.1-1.06-14.75-1.89h0l-.9-.08a4.38,4.38,0,0,0-.5,0c-4.37-.42-9.28-.72-14.38-.8-.92,0-1.84,0-2.77,0h-1.11c-6.18-6.07-4.67-21.39-2.37-33.89a6.31,6.31,0,0,0,1.76-.62,17.2,17.2,0,0,0,8-8.92,8.73,8.73,0,0,0,.52-4c7.15-7.32,15-14.63,19.34-24.43,6.28-14.08-.07-18.58-4.66-20a26.18,26.18,0,0,1,9.55,1.46c-3.42-3.89-7.08-4.53-10.19-4,3.42-3.19,3-8.65,3-8.65a22.65,22.65,0,0,1-4.43,7.16c2.79-9.64-15.23-16.84-39.65-10.44-18.09,4.74-27.31,2.47-27.31,2.47a9.71,9.71,0,0,0,4.63,6.09c-13.42,8.8-12.26,30.17-8.85,45.07a74.05,74.05,0,0,0-.86,7.41c-1,16.66,11.76,27.09,26.37,25,0,.3.11.6.16.91s.13.86.18,1.28c.12,1,.21,1.9.25,2.85.32,7.34-2.06,14.17-12.35,17.31h0c-2,.3-4,.64-6,1l-.66.12-2.23.41-1.16.23-1.78.35-1.09.22-1.84.38-.81.17-2.09.46-.48.1c-.76.17-1.5.34-2.23.49l-.39.1-1.31.29h0c-7,1.62-12,3-12,3-8.6,2.74-14,9.95-17,15.3l-5.94,0-.62-145,156.64-.67.62,145Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,146.73l-183,.79L72.09,320h183ZM233,305.49c-4.74-9.49-11.82-20.54-19.34-21.22,0,0-6.1-1.06-14.75-1.89h0l-.9-.08a4.38,4.38,0,0,0-.5,0c-4.37-.42-9.28-.72-14.38-.8-.92,0-1.84,0-2.77,0h-1.11c-6.18-6.07-4.67-21.39-2.37-33.89a6.31,6.31,0,0,0,1.76-.62,17.2,17.2,0,0,0,8-8.92,8.73,8.73,0,0,0,.52-4c7.15-7.32,15-14.63,19.34-24.43,6.28-14.08-.07-18.58-4.66-20a26.18,26.18,0,0,1,9.55,1.46c-3.42-3.89-7.08-4.53-10.19-4,3.42-3.19,3-8.65,3-8.65a22.65,22.65,0,0,1-4.43,7.16c2.79-9.64-15.23-16.84-39.65-10.44-18.09,4.74-27.31,2.47-27.31,2.47a9.71,9.71,0,0,0,4.63,6.09c-13.42,8.8-12.26,30.17-8.85,45.07a74.05,74.05,0,0,0-.86,7.41c-1,16.66,11.76,27.09,26.37,25,0,.3.11.6.16.91s.13.86.18,1.28c.12,1,.21,1.9.25,2.85.32,7.34-2.06,14.17-12.35,17.31h0c-2,.3-4,.64-6,1l-.66.12-2.23.41-1.16.23-1.78.35-1.09.22-1.84.38-.81.17-2.09.46-.48.1c-.76.17-1.5.34-2.23.49l-.39.1-1.31.29h0c-7,1.62-12,3-12,3-8.6,2.74-14,9.95-17,15.3l-5.94,0-.62-145,156.64-.67.62,145Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.18,317.59a.1.1,0,0,1-.07,0,.12.12,0,0,1,0-.08l-.82-167a.11.11,0,0,1,.11-.12l177-.76a.11.11,0,0,1,.09,0,.16.16,0,0,1,0,.09l.83,167a.12.12,0,0,1-.12.12l-177,.76Zm-.7-167,.82,166.74,176.82-.76-.83-166.74Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-462"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211,311.31h0c.55,0,1.11,0,1.68.05,11.88.85,21.49,10.91,22.25,23.29a26.28,26.28,0,0,1-.77,8.13,129.93,129.93,0,0,0-3.76,32.55v32a4.12,4.12,0,0,1-4,4.2H147V311.31Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,311.31h0c.55,0,1.11,0,1.68.05,11.88.85,21.49,10.91,22.25,23.29a26.28,26.28,0,0,1-.77,8.13,129.93,129.93,0,0,0-3.76,32.55v32a4.12,4.12,0,0,1-4,4.2H147V311.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,336.29c0-14.37,11.65-25.92,25.66-24.92,11.88.85,21.49,10.91,22.25,23.29a26.28,26.28,0,0,1-.77,8.13,129.93,129.93,0,0,0-3.76,32.55v32a4.12,4.12,0,0,1-4,4.2H131.6a4.11,4.11,0,0,1-4-4.2V373.46A118.44,118.44,0,0,0,123.86,343,26.19,26.19,0,0,1,123,336.29Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,336.29c0-14.37,11.65-25.92,25.66-24.92,11.88.85,21.49,10.91,22.25,23.29a26.28,26.28,0,0,1-.77,8.13,129.93,129.93,0,0,0-3.76,32.55v32a4.12,4.12,0,0,1-4,4.2H131.6a4.11,4.11,0,0,1-4-4.2V373.46A118.44,118.44,0,0,0,123.86,343,26.19,26.19,0,0,1,123,336.29Z",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.02,
    y: 350.66,
    width: 101.16,
    height: 60.82,
    transform: "translate(461.21 762.15) rotate(180)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.02,
    y: 350.66,
    width: 101.16,
    height: 60.82,
    transform: "translate(461.21 762.15) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,277.81H353.42a0,0,0,0,1,0,0v68.08a18.52,18.52,0,0,1-18.52,18.52H223.19a18.52,18.52,0,0,1-18.52-18.52V277.81A0,0,0,0,1,204.66,277.81Z",
    transform: "translate(558.08 642.22) rotate(180)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,277.81H353.42a0,0,0,0,1,0,0v68.08a18.52,18.52,0,0,1-18.52,18.52H223.19a18.52,18.52,0,0,1-18.52-18.52V277.81A0,0,0,0,1,204.66,277.81Z",
    transform: "translate(558.08 642.22) rotate(180)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82,277.81H330.56a0,0,0,0,1,0,0v69a17.63,17.63,0,0,1-17.63,17.63H217.45a17.63,17.63,0,0,1-17.63-17.63v-69A0,0,0,0,1,199.82,277.81Z",
    transform: "translate(530.38 642.22) rotate(180)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82,277.81H330.56a0,0,0,0,1,0,0v69a17.63,17.63,0,0,1-17.63,17.63H217.45a17.63,17.63,0,0,1-17.63-17.63v-69A0,0,0,0,1,199.82,277.81Z",
    transform: "translate(530.38 642.22) rotate(180)",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.51,344.33h94.07a5.46,5.46,0,0,1,5.46,5.46v14.63a5.46,5.46,0,0,1-5.46,5.46H177.51a1.63,1.63,0,0,1-1.63-1.63V346A1.63,1.63,0,0,1,177.51,344.33Z",
    transform: "translate(452.91 714.21) rotate(180)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.51,344.33h94.07a5.46,5.46,0,0,1,5.46,5.46v14.63a5.46,5.46,0,0,1-5.46,5.46H177.51a1.63,1.63,0,0,1-1.63-1.63V346A1.63,1.63,0,0,1,177.51,344.33Z",
    transform: "translate(452.91 714.21) rotate(180)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75,411.49H360.26a3,3,0,0,1,3,3v.06a0,0,0,0,1,0,0H145.77a0,0,0,0,1,0,0v-.06A3,3,0,0,1,148.75,411.49Z",
    transform: "translate(509.01 826.01) rotate(180)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75,411.49H360.26a3,3,0,0,1,3,3v.06a0,0,0,0,1,0,0H145.77a0,0,0,0,1,0,0v-.06A3,3,0,0,1,148.75,411.49Z",
    transform: "translate(509.01 826.01) rotate(180)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,209c4.73-3.71-2.23-9.77-14.25-9.71-8,0-11.58-1.87-11.58-1.87a4.15,4.15,0,0,0,1.27,3c-9.56,3.25-8.9,21.12-7.9,24.29L290.31,236c3-8.71,14.05-10.09,20-17.58S309,209,309,209Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.89,209.34s5-2.81,7.41,1.92A12,12,0,0,0,306.89,209.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.66,205.28s-.76,4.42-4.84,3.55A9.45,9.45,0,0,0,312.66,205.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.58,206.73l-6.68-1.06a.74.74,0,0,1-.6-1l4.83-15.63a1,1,0,0,1,1.1-.7l6.68,1.07a.73.73,0,0,1,.6,1L220.68,206A1,1,0,0,1,219.58,206.73Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.58,206.73l-6.68-1.06a.74.74,0,0,1-.6-1l4.83-15.63a1,1,0,0,1,1.1-.7l6.68,1.07a.73.73,0,0,1,.6,1L220.68,206A1,1,0,0,1,219.58,206.73Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,206.6l-6.69-1.06a.74.74,0,0,1-.59-1l4.83-15.63a1,1,0,0,1,1.1-.7l6.68,1.07a.73.73,0,0,1,.6,1l-4.83,15.64A1,1,0,0,1,218.76,206.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.78 336.03 227.03 335.92 226.72 322.81 235.47 322.92 235.78 336.03",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.6,334.9l9.84.12a.62.62,0,0,1,.63.61l.22,7.8A1.59,1.59,0,0,1,235.7,345c-3.42-.1-5-.32-9.37-.37-2.66,0-11.77.2-15.44.15s-3.45-3.68-1.89-4c7-1.4,13.54-3.42,16.08-5.34A2.56,2.56,0,0,1,226.6,334.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.47 322.92 226.72 322.82 226.96 333.3 235.72 333.4 235.47 322.92",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.53,336.4a2.43,2.43,0,0,1-1.71-.49,1.11,1.11,0,0,1-.22-1.12.78.78,0,0,1,.5-.57c1.09-.4,3.5,1.32,3.77,1.52a.22.22,0,0,1,.09.21.22.22,0,0,1-.16.16A10.89,10.89,0,0,1,223.53,336.4Zm-1-1.83a.66.66,0,0,0-.25,0,.37.37,0,0,0-.24.29.72.72,0,0,0,.12.72c.39.41,1.54.47,3.11.18A6.9,6.9,0,0,0,222.49,334.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.75,336.12a.17.17,0,0,1-.11,0c-.84-.52-2.09-2.36-1.87-3.32a.79.79,0,0,1,.76-.62,1,1,0,0,1,.86.29c.86.87.58,3.4.57,3.5a.2.2,0,0,1-.12.16A.16.16,0,0,1,225.75,336.12Zm-1.09-3.58h-.08c-.31,0-.38.18-.41.3-.15.66.71,2,1.41,2.66,0-.83,0-2.27-.48-2.78A.61.61,0,0,0,224.66,332.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.71,301.92c-4-.52-5.86.79-8.29-6.6C251.24,279.6,227.26,240.51,215,269c-10.82,25,6.62,54.93,10.1,60.49a2.59,2.59,0,0,0,1.74,1.16l8.5,1.78a7.59,7.59,0,0,0,2.89,0c3.59-.65,12.05-2.89,18.22-9.71,4.66-5.15,8.52-14.36,8.93-20a.68.68,0,0,0-.63-.79Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.71,301.92c-4-.52-5.86.79-8.29-6.6C251.24,279.6,227.26,240.51,215,269c-10.82,25,6.62,54.93,10.1,60.49a2.59,2.59,0,0,0,1.74,1.16l8.5,1.78a7.59,7.59,0,0,0,2.89,0c3.59-.65,12.05-2.89,18.22-9.71,4.66-5.15,8.52-14.36,8.93-20a.68.68,0,0,0-.63-.79Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.4,250.38c-1.62-.18-3-.38-4.53-.64s-2.94-.54-4.41-.85c-2.92-.61-5.81-1.41-8.69-2.31a60,60,0,0,1-16.65-7.88c-.65-.49-1.3-.94-1.92-1.47-.32-.28-.61-.49-1-.81a13.88,13.88,0,0,1-1-1,26.19,26.19,0,0,1-3-4,60.3,60.3,0,0,1-4.17-8.09,118.9,118.9,0,0,1-5.72-16.64l4.18-1.48c2.45,5.08,5,10.22,7.72,15a68.54,68.54,0,0,0,4.35,6.85,21.11,21.11,0,0,0,2.35,2.71,5.71,5.71,0,0,0,.55.48c.18.15.48.36.72.53.48.38,1,.71,1.55,1.07a59.68,59.68,0,0,0,14.62,6.22c2.61.77,5.29,1.38,8,2,1.34.29,2.69.55,4.05.79s2.75.46,4,.62Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.94,244.58c-2.38-5-19.77-5-19.77-5l.47,17.24s9,.8,13.26-2C269.31,251.83,273.18,249.29,270.94,244.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.62,207.23l6.87-6.3-9.07-2.79s-3.76,7.28-1.51,10.17Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.09 193.61 212.64 193.43 209.42 198.14 218.49 200.93 220.09 193.61",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.46 336.03 253.71 335.92 253.4 322.81 262.16 322.92 262.46 336.03",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29,334.9l9.83.12a.62.62,0,0,1,.63.61l.22,7.8a1.59,1.59,0,0,1-1.58,1.54c-3.42-.1-5.05-.32-9.38-.37-2.66,0-10.63.2-14.3.15s-3.45-3.68-1.88-4c7-1.4,12.4-3.42,14.93-5.34A2.59,2.59,0,0,1,253.29,334.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.16 322.92 253.4 322.82 253.65 333.3 262.4 333.4 262.16 322.92",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,241.48s-5.1,4.09-12,56.17c8.38,1,26.82,3,34.9,3.32,3.65-14.34,6.23-23.11,21.55-51a94.75,94.75,0,0,0-14-4.82,107.39,107.39,0,0,0-15.55-3.07C269,241.39,261,241.48,261,241.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.52,242.05c-.94-.38-3.39-.58-5.89,1.92s.25,6,.25,6l5.64-3Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.52,247.67l1.36,5.83s14.9-2.5,11.63-8.06l-2.82-.88Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.9,252c-.31.83-1,1.47-1.48,1.44s-.67-.73-.36-1.56,1-1.47,1.48-1.44S277.21,251.15,276.9,252Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.9,252c-.31.83-1,1.47-1.48,1.44s-.67-.73-.36-1.56,1-1.47,1.48-1.44S277.21,251.15,276.9,252Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,227c-2.5,4.92-7,14.08-4.52,18.18,0,0-2.91,4.91-12.2,3.07-10.23-2-3.35-6.14-3.35-6.14,6-.26,7.09-4.51,7.29-8.67Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.31,229.61l-7.11,3.8a17.53,17.53,0,0,1-.36,2.92c2.23.1,5.86-1.71,6.77-3.94A8.4,8.4,0,0,0,290.31,229.61Z",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,220.37c-5,7.59-7,10.9-13.1,13-9.17,3.19-16.87-3.68-14.08-12.39,2.5-7.84,10.29-18.94,19.39-18.38S307.06,212.77,302,220.37Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.39,205.42c8.49-1,9.76,7.05,14.3,5.41,0,0-3.22,2.36-1.06,15.1l4.44-1.43L308,211.45l-2.75-4.62S295.61,195.69,283.39,205.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.08,228a7.34,7.34,0,0,1-4.24,2.84c-2.22.49-3-1.48-2.1-3.48.82-1.79,2.95-4.21,5.05-3.81S300.33,226.25,299.08,228Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,222.39c-2.87-.89-5.33-1.75-10.51,3.54A25.25,25.25,0,0,1,302.3,222.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.62,222.48c-2.2-1.28-4.06-2.45-9.34.93A21.33,21.33,0,0,1,302.62,222.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.48,216.86c-.37.63-1,1-1.39.79s-.41-.88,0-1.52,1-1,1.39-.79S289.85,216.22,289.48,216.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.64,213.4c-.38.64-1,1-1.39.79s-.42-.88-.05-1.52,1-1,1.39-.79S283,212.76,282.64,213.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.75,212l-1.2-1.18S281.6,212.4,282.75,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.81,215.41a21.75,21.75,0,0,1-4.54,3c.35,1.19,1.91,1.52,1.91,1.52Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.56,224.14a6,6,0,0,1-2.69-.65.21.21,0,0,1,.18-.38,5.69,5.69,0,0,0,5.07,0,.21.21,0,0,1,.28.08.2.2,0,0,1-.07.28A6,6,0,0,1,284.56,224.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,215.66a.42.42,0,0,1-.41-.36,5,5,0,0,0-1.5-3.12.42.42,0,0,1,.51-.66,5.7,5.7,0,0,1,1.81,3.66.4.4,0,0,1-.35.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,207.78a.37.37,0,0,1-.24-.08,3.33,3.33,0,0,0-3-.16.4.4,0,0,1-.53-.24.41.41,0,0,1,.24-.53,4.14,4.14,0,0,1,3.81.26.42.42,0,0,1-.25.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21,336.4a2.4,2.4,0,0,1-1.7-.49,1.11,1.11,0,0,1-.23-1.12.8.8,0,0,1,.51-.57c1.08-.39,3.5,1.32,3.77,1.52a.2.2,0,0,1,.08.21.22.22,0,0,1-.16.16A10.8,10.8,0,0,1,250.21,336.4Zm-1-1.83a.61.61,0,0,0-.24,0,.34.34,0,0,0-.24.29.7.7,0,0,0,.11.72c.4.41,1.55.47,3.12.18A7,7,0,0,0,249.17,334.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.44,336.12a.15.15,0,0,1-.11,0c-.85-.52-2.09-2.36-1.88-3.32a.81.81,0,0,1,.77-.62,1,1,0,0,1,.86.29c.86.87.58,3.4.56,3.5a.19.19,0,0,1-.11.16A.16.16,0,0,1,252.44,336.12Zm-1.09-3.58h-.09c-.3,0-.37.18-.4.3-.15.66.71,2,1.4,2.66.05-.83,0-2.27-.48-2.78A.59.59,0,0,0,251.35,332.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.59,215.46l-1.2-1.17S288.44,215.86,289.59,215.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,299l.32,3.25c0,.27-.26.48-.67.45l-36.2-3c-.32,0-.55-.21-.54-.41l.28-3.2c0-.22.32-.39.67-.36l35.62,3A.57.57,0,0,1,285,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.44,302.63l1,.08c.18,0,.35-.07.36-.19l.32-4.17c0-.12-.14-.23-.33-.25l-1-.07c-.19,0-.35.07-.36.19l-.32,4.16C279.1,302.5,279.25,302.62,279.44,302.63Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.44,302.63l1,.08c.18,0,.35-.07.36-.19l.32-4.17c0-.12-.14-.23-.33-.25l-1-.07c-.19,0-.35.07-.36.19l-.32,4.16C279.1,302.5,279.25,302.62,279.44,302.63Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,300.27l1,.08c.19,0,.35-.08.36-.2l.32-4.16c0-.12-.14-.23-.33-.25l-1-.08c-.19,0-.36.07-.37.19L250.7,300C250.7,300.14,250.84,300.25,251,300.27Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,300.27l1,.08c.19,0,.35-.08.36-.2l.32-4.16c0-.12-.14-.23-.33-.25l-1-.08c-.19,0-.36.07-.37.19L250.7,300C250.7,300.14,250.84,300.25,251,300.27Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.24,301.45l.95.08c.19,0,.35-.07.36-.19l.32-4.17c0-.12-.14-.23-.33-.25l-1-.08c-.19,0-.35.07-.36.2l-.32,4.16C264.9,301.32,265.05,301.43,265.24,301.45Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.24,301.45l.95.08c.19,0,.35-.07.36-.19l.32-4.17c0-.12-.14-.23-.33-.25l-1-.08c-.19,0-.35.07-.36.2l-.32,4.16C264.9,301.32,265.05,301.43,265.24,301.45Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.14,301.92c-4.12-.52-5.62.79-10.22-6.6-9.77-15.72-45.19-54.81-49.17-26.35-3.5,25,22.69,54.93,27.8,60.49a3.76,3.76,0,0,0,2.08,1.16l9,1.78a7.6,7.6,0,0,0,2.89,0c3.4-.65,11.2-2.89,15.37-9.71,3.15-5.15,4.32-14.36,3.1-20a1,1,0,0,0-.87-.79Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.14,301.92c-4.12-.52-5.62.79-10.22-6.6-9.77-15.72-45.19-54.81-49.17-26.35-3.5,25,22.69,54.93,27.8,60.49a3.76,3.76,0,0,0,2.08,1.16l9,1.78a7.6,7.6,0,0,0,2.89,0c3.4-.65,11.2-2.89,15.37-9.71,3.15-5.15,4.32-14.36,3.1-20a1,1,0,0,0-.87-.79Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.57,261.83c.59,2.61,1,5.05,1.38,7.58s.67,5,.91,7.55.41,5.07.54,7.61.11,5.11,0,7.67c-.05,1.29-.08,2.57-.18,3.86l-.14,1.93,0,.24,0,.36c0,.23-.06.47-.11.7a9.84,9.84,0,0,1-.34,1.4,12.06,12.06,0,0,1-2.79,4.73A15.73,15.73,0,0,1,302,308.4a26.75,26.75,0,0,1-7.92,2.82,33.39,33.39,0,0,1-3.94.57,34.61,34.61,0,0,1-4,.17l-.44-4.71c4.38-1.19,9.06-2.88,12.16-5.25a9.19,9.19,0,0,0,1.82-1.82,4,4,0,0,0,.73-1.71,2.71,2.71,0,0,0,0-.4,1.48,1.48,0,0,0,0-.21v-.33l0-1.76c0-1.18,0-2.36,0-3.54,0-2.37-.19-4.75-.38-7.12s-.39-4.76-.69-7.14-.63-4.75-1-7.12-.78-4.77-1.2-7Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.41,250c5.39,1.91,6.78,17.08,6.78,17.08l-16.06,7.38s-4.34-12.92-1.84-17.45C296.9,252.28,301.13,248.46,305.41,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.69,307.29l-9-2.83L280,312s5.84,2,8.42-.95Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.24 307.7 272.13 314.92 280.03 311.95 277.73 304.46 271.24 307.7",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.69,287S262.5,312.17,264.35,327C264.35,327,265.23,297,250.69,287Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.69,287S262.5,312.17,264.35,327C264.35,327,265.23,297,250.69,287Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.93,
    y: 379.57,
    width: 1,
    height: 11.99,
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.93,
    y: 379.57,
    width: 1,
    height: 11.99,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.93,
    y: 396.17,
    width: 1,
    height: 4.26,
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.93,
    y: 396.17,
    width: 1,
    height: 4.26,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,311.31h0c.56,0,1.12,0,1.69.05,11.88.85,21.49,10.91,22.24,23.29a25.69,25.69,0,0,1-.77,8.13,130.39,130.39,0,0,0-3.76,32.55v32a4.11,4.11,0,0,1-4,4.2H280V311.31Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,311.31h0c.56,0,1.12,0,1.69.05,11.88.85,21.49,10.91,22.24,23.29a25.69,25.69,0,0,1-.77,8.13,130.39,130.39,0,0,0-3.76,32.55v32a4.11,4.11,0,0,1-4,4.2H280V311.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,336.29c0-14.37,11.66-25.92,25.67-24.92,11.88.85,21.49,10.91,22.24,23.29a25.69,25.69,0,0,1-.77,8.13,130.39,130.39,0,0,0-3.76,32.55v32a4.11,4.11,0,0,1-4,4.2H264.67a4.12,4.12,0,0,1-4-4.2V373.46A118.43,118.43,0,0,0,256.93,343,25.75,25.75,0,0,1,256.06,336.29Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,336.29c0-14.37,11.66-25.92,25.67-24.92,11.88.85,21.49,10.91,22.24,23.29a25.69,25.69,0,0,1-.77,8.13,130.39,130.39,0,0,0-3.76,32.55v32a4.11,4.11,0,0,1-4,4.2H264.67a4.12,4.12,0,0,1-4-4.2V373.46A118.43,118.43,0,0,0,256.93,343,25.75,25.75,0,0,1,256.06,336.29Z",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomeIllustration);
export default __webpack_public_path__ + "static/media/some_illustration.a9baac6b077714f8cda3da5d78064039.svg";
export { ForwardRef as ReactComponent };